'use client';

import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';

const useAccountExists = () => {
	const currentAccountExists = useVelocityAccountStore(
		(s) => s.currentUserExists
	);

	return currentAccountExists;
};

export default useAccountExists;
